export let transactionTypeMeta = {
	'transaction/invoice': {payments: -1, named: 'Invoice'}
  , 'transaction/invoice-payment': {payments: 1, named: 'Payment'}
  , 'transaction/credit': {payments: 1, named: 'Credit'}
  ,	'transaction/refund': {payments: -1, named: 'Refund'}
  ,	'transaction/deposit-use': {payments: 1, named: 'Deposit use'}
  ,	'transaction/deposit-refund': {payments: 0, named: 'Deposit Refund'}
  ,	'transaction/bad-debt': {payments: 1, named: 'Bad debt'}
}



// WEBPACK FOOTER //
// ./src/helpers/accounting.js